<template>
  <content-container>
    <section>
      <h1>Компоненты кабинета</h1>
      <b-container fluid>
        <b-row align-h="between">
          <b-col
            cols="5"
            style="min-height: 450px"
            class="d-flex align-items-center border border-secondary rounded p-2"
          >
            <div class="flex-fill m-5">
              <h2>Пример формы</h2>
              <b-form @submit="onSubmit">
                <b-overlay :show="loading" variant="white" opacity="0.7">
                  <!-- ### Email ################################################## -->
                  <b-form-group
                    id="input-group-1"
                    :label="$t('login.form.email.label')"
                    label-for="input-1"
                  >
                    <b-form-input
                      id="input-1"
                      autofocus
                      :disabled="loading"
                      v-model="$v.form.email.$model"
                      :state="validateState('email')"
                      aria-describedby="input-1-ifeedback"
                      :placeholder="$t('login.form.email.ph')"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-1-ifeedback">{{
                      $t("form.validEmail")
                    }}</b-form-invalid-feedback>
                  </b-form-group>

                  <!-- ### Password ################################################## -->
                  <b-form-group
                    id="input-group-2"
                    :label="$t('login.form.pass.label')"
                    label-for="input-2"
                  >
                    <b-form-input
                      id="input-2"
                      :disabled="loading"
                      v-model="$v.form.password.$model"
                      :placeholder="$t('login.form.pass.ph')"
                      :state="validateState('password')"
                      type="password"
                    ></b-form-input>
                    <b-form-invalid-feedback>{{
                      $t("form.required")
                    }}</b-form-invalid-feedback>
                  </b-form-group>

                  <!-- ### Remember me ################################################## -->
                  <b-form-group id="input-group-3">
                    <b-form-checkbox
                      v-model="form.remember"
                      :disabled="loading"
                      switch
                      >{{ $t("login.form.remember") }}</b-form-checkbox
                    >
                  </b-form-group>
                </b-overlay>

                <b-container class="p-0">
                  <b-row>
                    <b-col sm="6">
                      <b-button
                        type="submit"
                        variant="primary"
                        class="w-100 mt-3"
                        :disabled="loading"
                        >{{ $t("login.form.button") }}</b-button
                      >
                    </b-col>
                  </b-row>
                </b-container>
              </b-form>
            </div>
          </b-col>
          <b-col cols="6">
            <h2>Другие компоненты</h2>
            <div class="button-view">
              <b-button variant="primary">Primary</b-button>
              <b-button variant="secondary">Secondary</b-button>
              <b-button variant="success">Success</b-button>
              <b-button variant="danger">Danger</b-button>
              <b-button variant="warning">Warning</b-button>
              <b-button variant="info">Info</b-button>
              <b-button variant="light">Light</b-button>
              <b-button variant="dark">Dark</b-button>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section>
      <!-- simple-card ===========================================================================-->
      <simple-card :loading="loading" id="user-email">
        <template v-slot:title>
          {{ $t("profile.comm.email.title") }}
        </template>
        <template v-slot:description>
          <div v-if="$store.state.user.emails.length">
            <div
              class="email"
              v-for="email in $store.state.user.emails"
              :key="email.id"
            >
              {{ email.email }}
              <span class="text-success" v-if="email.verified"
                >({{ $t("profile.comm.email.verified") }})</span
              >
              <span class="text-danger" v-else
                >({{ $t("profile.comm.email.unverified") }})</span
              >
              <!-- Перепосылка кода --------------->
              <div class="ml-3 d-inline-block">
                <b-overlay
                  :show="resending"
                  rounded
                  opacity="0.7"
                  spinner-small
                  spinner-variant="light"
                  class="d-inline-block"
                >
                  <b-button
                    v-if="!email.verified"
                    size="sm"
                    variant="success"
                    @click="resendClick(email)"
                    :disabled="!canResend && !resending"
                  >
                    <template v-if="canResend">
                      {{ $t("profile.comm.email.resend") }}
                    </template>
                    <template v-else>
                      {{ $t("verification.nextIn", [remaining]) }}
                    </template>
                  </b-button>
                </b-overlay>

                <!-- Удаление не проверенного -------->
                <b-overlay
                  :show="deleting"
                  rounded
                  opacity="0.7"
                  spinner-small
                  spinner-variant="light"
                  class="d-inline-block"
                >
                  <b-button
                    v-if="!email.verified"
                    size="sm"
                    variant="danger"
                    class="ml-3"
                    :disabled="deleting"
                    @click="deleteClick(email)"
                    ><b-icon-x></b-icon-x
                  ></b-button>
                </b-overlay>
              </div>
            </div>
          </div>
          <span class="text-danger" v-else>{{
            $t("profile.comm.email.empty")
          }}</span>
        </template>
        <template v-slot:pane>
          <!-- Изменить текущий или установить адрес почты впервые -->
          <b-button
            v-if="$store.state.user.emails.length"
            variant="primary"
            @click="showChangeEmail()"
          >
            {{ $t("profile.comm.email.change_nice") }}
          </b-button>
          <b-button v-else variant="danger" @click="showNewEmail()">{{
            $t("profile.comm.email.set")
          }}</b-button>
        </template>
      </simple-card>

      <!-- collapsible-card ===========================================================================-->
      <collapsible-card :loading="loading">
        <template v-slot:title> Collapsible Card </template>
        <template v-slot:description>
          Раскладушка для настроек, которые крутяться одним кусочком.
        </template>
        <template v-slot:content>
          <b-form-group
            id="fieldset-1"
            :description="$t('profile.comm.pref.blog.desc')"
            label-for="blog-cb"
          >
            <b-form-checkbox
              id="blog-cb"
              name="blog"
              switch
              v-model="test_array.mail_blog"
            >
              {{ $t("profile.comm.pref.blog.title") }}
            </b-form-checkbox>
          </b-form-group>

          <b-form-group
            id="fieldset-2"
            :description="$t('profile.comm.pref.events.desc')"
            label-for="events-cb"
          >
            <b-form-checkbox
              id="events-cb"
              name="events"
              switch
              v-model="test_array.mail_events"
            >
              {{ $t("profile.comm.pref.events.title") }}
            </b-form-checkbox>
          </b-form-group>

          <b-form-group
            id="fieldset-3"
            :description="$t('profile.comm.pref.promo.desc')"
            label-for="promo-cb"
          >
            <b-form-checkbox
              id="promo-cb"
              name="promos"
              switch
              v-model="test_array.mail_promotion"
            >
              {{ $t("profile.comm.pref.promo.title") }}
            </b-form-checkbox>
          </b-form-group>
        </template>
      </collapsible-card>
    </section>
  </content-container>
</template>

<script>
// @ is an alias to /src
import { validationMixin } from "vuelidate";
import { required, email, or } from "vuelidate/lib/validators";
import CollapsibleCard from "../CollapsibleCard.vue";
import ContentContainer from '../ContentContainer.vue';
import SimpleCard from "../SimpleCard.vue";

export default {
  components: { SimpleCard, CollapsibleCard, ContentContainer },
  name: "Pages",
  mixins: [validationMixin],
  data() {
    return {
      form: {
        email: "",
        password: "",
        remember: false,
      },
      loading: false,
      root: "root",
      test_array: {
        mail_blog: false,
        mail_events: false,
        mail_promotion: false,
      },
    };
  },
  validations: {
    form: {
      email: {
        required,
        custom: or(email, function (value) {
          return value.toLowerCase() === "root";
        }),
      },
      password: {
        required,
      },
    },
  },
  computed: {
    isRoot() {
      return this.form.email === "root";
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.$v.form.$touch();
    },
  },
};
</script>

<style scoped>
.button-view button {
  margin: 1em;
}
</style>